import { render } from "./Subscription.vue?vue&type=template&id=2fbf455f&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"

import "./Subscription.vue?vue&type=style&index=0&id=2fbf455f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbf455f"]])

export default __exports__